import { Script, injector } from '../shared/injector.js';

import Highcharts from 'highcharts/highcharts.js';


injector.injectClass(class extends Script {
    onLoad() {
        const data = window.JSON_data;

        const remainingBalance = [];
        const tokensIn = [];
        const cachedTokensIn = [];
        const tokensOut = [];

        for (const date in data) {
            const ts = Date.parse(date);
            remainingBalance.push([ts, data[date].balance_usd]);
            tokensIn.push([ts, data[date].used_tokens_in - data[date].cached_tokens_in]);
            cachedTokensIn.push([ts, data[date].cached_tokens_in]);
            tokensOut.push([ts, data[date].used_tokens_out]);
        }

        Highcharts.chart('chart', {
            title: { text: 'Test' },
            xAxis: {
                type: 'datetime',
            },
            yAxis: [{
                title: { text: 'Remaining Balance (USD)' },
                labels: { format: '${value}' },
                min: 0,
            }, {
                title: { text: 'Tokens Used' },
                opposite: true,
            }],
            series: [{
                name: 'Tokens In',
                type: 'column',
                data: tokensIn,
                yAxis: 1,
            }, {
                name: 'Cached Tokens In',
                type: 'column',
                data: cachedTokensIn,
                yAxis: 1,
            }, {
                name: 'Tokens Out',
                type: 'column',
                data: tokensOut,
                yAxis: 1,
            }, {
                name: 'Remaining Balance',
                data: remainingBalance,
            }],
            plotOptions: {
                column: {
                    stacking: 'normal',
                    pointWidth: 10,
                },
            },
        });
    }
}, ['ai-dashboard']);
